export function urlBase64ToUint8Array(value: string) {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = `${value}${padding}`.replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);

  for (let index = 0; index < raw.length; index += 1) {
    output[index] = raw.charCodeAt(index);
  }

  return output;
}

export async function getExistingSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return null;
  }

  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function subscribeToPush(publicKey: string) {
  const registration = await navigator.serviceWorker.ready;
  const existingSubscription = await registration.pushManager.getSubscription();

  if (existingSubscription) {
    return existingSubscription;
  }

  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });
}

export async function getClientPushDiagnostics() {
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches || Boolean('standalone' in navigator && navigator.standalone);
  const hasServiceWorker = 'serviceWorker' in navigator;
  const hasPushManager = 'PushManager' in window;
  const registration = hasServiceWorker ? await navigator.serviceWorker.ready.catch(() => null) : null;
  const subscription = registration && hasPushManager ? await registration.pushManager.getSubscription() : null;

  return {
    isSecureContext: window.isSecureContext,
    isStandalone: standalone,
    hasServiceWorker,
    hasPushManager,
    notificationPermission: 'Notification' in window ? Notification.permission : 'unsupported',
    hasServiceWorkerRegistration: Boolean(registration),
    hasBrowserSubscription: Boolean(subscription),
    endpointHost: subscription ? new URL(subscription.endpoint).host : '',
  };
}
